import { useEffect, useRef } from 'react';

export default function MouthpieceOutcome() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .fade-up-item').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const outcomes = [
    '今の歯並びについて、治療を考える必要があるかどうかが理解できている',
    '自分に合いそうな治療の選択肢が、把握できている',
    '生活や性格の面で、マウスピース矯正が合うかが把握できている',
    '今すぐ決めなくてもいい、という見通しが立っている',
  ];

  return (
    <section ref={sectionRef} className="py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl md:text-4xl font-normal text-center text-gray-900 mb-16 fade-up font-serif"
        >
          この相談を終えたとき、<br />
          あなたは次の内容を理解できています。
        </h2>

        <div className="space-y-6 mb-12">
          {outcomes.map((outcome, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-white p-6 rounded-lg fade-up-item"
            >
              <div
                className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center"
                style={{ backgroundColor: '#3E5F8F' }}
              >
                <i className="ri-check-line text-white" />
              </div>
              <p className="text-gray-800 text-lg pt-1">{outcome}</p>
            </div>
          ))}
        </div>

        <div className="text-center text-gray-600 fade-up">
          <p>※ 判断を急ぐ必要はありません。</p>
          <p>※ 結論が「今はやらない」になることもあります。</p>
        </div>
      </div>
    </section>
  );
}